/* tslint:disable */
/* eslint-disable */
/**
 * MINDD STIM 3
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ModuleCommissionEntity } from '../model';
// @ts-ignore
import type { OrganizationCommissionStatus } from '../model';
// @ts-ignore
import type { StationCommissionEntity } from '../model';
/**
 * CommissionControllerApi - axios parameter creator
 * @export
 */
export const CommissionControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} stationDeviceId 
         * @param {number} moduleDeviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commitModule: async (stationDeviceId: number, moduleDeviceId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stationDeviceId' is not null or undefined
            assertParamExists('commitModule', 'stationDeviceId', stationDeviceId)
            // verify required parameter 'moduleDeviceId' is not null or undefined
            assertParamExists('commitModule', 'moduleDeviceId', moduleDeviceId)
            const localVarPath = `/1.0/commissions/module`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (stationDeviceId !== undefined) {
                localVarQueryParameter['stationDeviceId'] = stationDeviceId;
            }

            if (moduleDeviceId !== undefined) {
                localVarQueryParameter['moduleDeviceId'] = moduleDeviceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 스테이션을 기관에 사용등록한다.
         * @param {number} deviceId 
         * @param {number} orgId 
         * @param {CommitStationTierTypeEnum} tierType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commitStation: async (deviceId: number, orgId: number, tierType: CommitStationTierTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('commitStation', 'deviceId', deviceId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('commitStation', 'orgId', orgId)
            // verify required parameter 'tierType' is not null or undefined
            assertParamExists('commitStation', 'tierType', tierType)
            const localVarPath = `/1.0/commissions/station`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (deviceId !== undefined) {
                localVarQueryParameter['deviceId'] = deviceId;
            }

            if (orgId !== undefined) {
                localVarQueryParameter['orgId'] = orgId;
            }

            if (tierType !== undefined) {
                localVarQueryParameter['tierType'] = tierType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        decommitModule: async (deviceId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('decommitModule', 'deviceId', deviceId)
            const localVarPath = `/1.0/commissions/module`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (deviceId !== undefined) {
                localVarQueryParameter['deviceId'] = deviceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 스테이션의 기관 등록을 해지한다.
         * @param {number} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        decommitStation: async (deviceId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('decommitStation', 'deviceId', deviceId)
            const localVarPath = `/1.0/commissions/station`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (deviceId !== undefined) {
                localVarQueryParameter['deviceId'] = deviceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 부르는 사용자가 속한 기관의 스테이션 사용등록 현황을 조회한다. 해지되지 않은 사용등록이 1건 이상이면 commissioned=true 이다. 기관은 토큰에서 유도하므로 요청 인자로 받지 않는다. 사용등록 이력이 없는 기관도 200 + commissioned=false 로 응답한다 — 기관 존재 여부는 이 서버가 알지 못한다.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationCommissionStatus: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/1.0/commissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CommissionControllerApi - functional programming interface
 * @export
 */
export const CommissionControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CommissionControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} stationDeviceId 
         * @param {number} moduleDeviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commitModule(stationDeviceId: number, moduleDeviceId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModuleCommissionEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commitModule(stationDeviceId, moduleDeviceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommissionControllerApi.commitModule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 스테이션을 기관에 사용등록한다.
         * @param {number} deviceId 
         * @param {number} orgId 
         * @param {CommitStationTierTypeEnum} tierType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commitStation(deviceId: number, orgId: number, tierType: CommitStationTierTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StationCommissionEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commitStation(deviceId, orgId, tierType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommissionControllerApi.commitStation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async decommitModule(deviceId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.decommitModule(deviceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommissionControllerApi.decommitModule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 스테이션의 기관 등록을 해지한다.
         * @param {number} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async decommitStation(deviceId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.decommitStation(deviceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommissionControllerApi.decommitStation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 부르는 사용자가 속한 기관의 스테이션 사용등록 현황을 조회한다. 해지되지 않은 사용등록이 1건 이상이면 commissioned=true 이다. 기관은 토큰에서 유도하므로 요청 인자로 받지 않는다. 사용등록 이력이 없는 기관도 200 + commissioned=false 로 응답한다 — 기관 존재 여부는 이 서버가 알지 못한다.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationCommissionStatus(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationCommissionStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationCommissionStatus(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommissionControllerApi.getOrganizationCommissionStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CommissionControllerApi - factory interface
 * @export
 */
export const CommissionControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CommissionControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} stationDeviceId 
         * @param {number} moduleDeviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commitModule(stationDeviceId: number, moduleDeviceId: number, options?: any): AxiosPromise<ModuleCommissionEntity> {
            return localVarFp.commitModule(stationDeviceId, moduleDeviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 스테이션을 기관에 사용등록한다.
         * @param {number} deviceId 
         * @param {number} orgId 
         * @param {CommitStationTierTypeEnum} tierType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commitStation(deviceId: number, orgId: number, tierType: CommitStationTierTypeEnum, options?: any): AxiosPromise<StationCommissionEntity> {
            return localVarFp.commitStation(deviceId, orgId, tierType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        decommitModule(deviceId: number, options?: any): AxiosPromise<void> {
            return localVarFp.decommitModule(deviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 스테이션의 기관 등록을 해지한다.
         * @param {number} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        decommitStation(deviceId: number, options?: any): AxiosPromise<void> {
            return localVarFp.decommitStation(deviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 부르는 사용자가 속한 기관의 스테이션 사용등록 현황을 조회한다. 해지되지 않은 사용등록이 1건 이상이면 commissioned=true 이다. 기관은 토큰에서 유도하므로 요청 인자로 받지 않는다. 사용등록 이력이 없는 기관도 200 + commissioned=false 로 응답한다 — 기관 존재 여부는 이 서버가 알지 못한다.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationCommissionStatus(options?: any): AxiosPromise<OrganizationCommissionStatus> {
            return localVarFp.getOrganizationCommissionStatus(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CommissionControllerApi - object-oriented interface
 * @export
 * @class CommissionControllerApi
 * @extends {BaseAPI}
 */
export class CommissionControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} stationDeviceId 
     * @param {number} moduleDeviceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommissionControllerApi
     */
    public commitModule(stationDeviceId: number, moduleDeviceId: number, options?: RawAxiosRequestConfig) {
        return CommissionControllerApiFp(this.configuration).commitModule(stationDeviceId, moduleDeviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 스테이션을 기관에 사용등록한다.
     * @param {number} deviceId 
     * @param {number} orgId 
     * @param {CommitStationTierTypeEnum} tierType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommissionControllerApi
     */
    public commitStation(deviceId: number, orgId: number, tierType: CommitStationTierTypeEnum, options?: RawAxiosRequestConfig) {
        return CommissionControllerApiFp(this.configuration).commitStation(deviceId, orgId, tierType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} deviceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommissionControllerApi
     */
    public decommitModule(deviceId: number, options?: RawAxiosRequestConfig) {
        return CommissionControllerApiFp(this.configuration).decommitModule(deviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 스테이션의 기관 등록을 해지한다.
     * @param {number} deviceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommissionControllerApi
     */
    public decommitStation(deviceId: number, options?: RawAxiosRequestConfig) {
        return CommissionControllerApiFp(this.configuration).decommitStation(deviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 부르는 사용자가 속한 기관의 스테이션 사용등록 현황을 조회한다. 해지되지 않은 사용등록이 1건 이상이면 commissioned=true 이다. 기관은 토큰에서 유도하므로 요청 인자로 받지 않는다. 사용등록 이력이 없는 기관도 200 + commissioned=false 로 응답한다 — 기관 존재 여부는 이 서버가 알지 못한다.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommissionControllerApi
     */
    public getOrganizationCommissionStatus(options?: RawAxiosRequestConfig) {
        return CommissionControllerApiFp(this.configuration).getOrganizationCommissionStatus(options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const CommitStationTierTypeEnum = {
    Standard: 'STANDARD',
    Research: 'RESEARCH'
} as const;
export type CommitStationTierTypeEnum = typeof CommitStationTierTypeEnum[keyof typeof CommitStationTierTypeEnum];
